import moment from 'moment';
import { capitalizeFirstLetter } from './capitalize-first-letter.util';

export const formatCustomDate = (dateStr: string, lang: string): string => {
  const currentLanguage = lang;

  // Detectar formato
  const parts = dateStr.split('/');

  if (parts.length === 3) {
    // Formato DD/MM/YYYY
    const [day, month, year] = parts;
    // Usamos moment para formatear el mes y el año
    const formattedMonth = moment().month(Number(month) - 1).locale(currentLanguage).format('MMM').replace('.', '');
    return `${String(day).padStart(2, '0')}-${capitalizeFirstLetter(formattedMonth)}-${year}`;
  } else if (parts.length === 2) {
    // Formato MM/YYYY
    const [month, year] = parts;
    // Usamos moment para formatear el mes y el año
    const formattedMonth = moment().month(Number(month) - 1).locale(currentLanguage).format('MMM').replace('.', '');
    return `${capitalizeFirstLetter(formattedMonth)}-${year}`;
  } else {
    return 'Formato inválido';
  }
}
